/**
 * attachmentStripSx — sx helper functions for AttachmentStrip components.
 * Keeps component JSX clean and sx props reusable across the strip.
 */

/**
 * Returns sx props for a single attachment thumbnail box.
 * @returns {object} MUI sx props
 */
export const getAttachmentThumbSx = () => ({
    width: 48,
    height: 48,
    flexShrink: 0,
    borderRadius: 1,
    overflow: 'hidden',
    cursor: 'pointer',
    border: '1px solid var(--j-border-color)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { borderColor: 'var(--j-accent)' },
});

/**
 * Returns style props for the img inside a thumbnail.
 * Applies stored rotation — 0 if not set.
 * @param {number} rotation - degrees: 0, 90, 180, 270
 * @returns {object} React style props
 */
export const getAttachmentThumbImgStyle = (rotation) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transform: `rotate(${rotation ?? 0}deg)`,
});
